<div class="card-header py-0 flex-row justify-content-between">
  <div class="d-flex align-items-stretch gap-24">
    <button
      type="button"
      class="btn btn-secondary d-flex align-items-center gap-2 align-self-center"
      [disabled]="disableControls"
      (click)="profileViewChange.emit(false)"
    >
      <i class="icon ic-arrow-left-20"></i>
      <span>Back</span>
    </button>

    <app-divider class="h-100" [vertical]="true"/>

    <div class="profile-title align-self-center">Officeholder Profile</div>
  </div>

  <div class="d-flex align-items-center gap-12">
    <button
      type="button"
      class="btn btn-primary d-flex align-items-center gap-2 align-self-center"
      [disabled]="disableControls"
      (click)="onEditOfficer()"
    >
      <i class="icon ic-edit-20"></i>
      <span>Edit Director ID</span>
    </button>

    <div ngbDropdown class="dropdown">
      <button
        ngbDropdownToggle
        id="company-actions-dd"
        class="btn btn-primary d-flex align-items-center gap-2"
        [disabled]="disableControls"
      >
        <span>Actions</span>
        <i class="icon ic-select-20"></i>
      </button>

      <div
        ngbDropdownMenu
        aria-labelledby="company-actions-dd"
        class="dropdown-menu dropdown-menu-right"
      >
        <div ngbDropdownItem class="dropdown-item">
          <a class="dropdown-button" (click)="onCompanyChangePartyName()">
            <i class="icon ic-change-officer-name-20"></i>

            <div class="document">
              <div class="title">Change Officer Name</div>
              <div class="asic-form">Form 484A2</div>
            </div>
          </a>
        </div>

        <div ngbDropdownItem class="dropdown-item">
          <a class="dropdown-button" (click)="onChangeOfficerAddress()">
            <i class="icon ic-change-address-20"></i>

            <div class="document">
              <div class="title">Change of Address</div>
              <div class="asic-form">Form 484A1</div>
            </div>
          </a>
        </div>

        <div ngbDropdownItem class="dropdown-item">
          <a class="dropdown-button" (click)="onCeaseRegisteredAgent()">
            <i class="icon ic-cessation-of-officeholder-20"></i>

            <div class="document">
              <div class="title">Cessation of Officeholder</div>
              <div class="asic-form">Form 484B1</div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card-body" [class.changes-hidden]="!isPendingChangesVisible">
  <div class="officeholder-info-container">
    <div>
      <div class="title">Officeholder Name</div>
      <a
        class="d-flex align-items-center gap-8"
        [routerLink]="officeholder.individualId ? ['/individuals', officeholder.individualId] : null"
      >
        <div>
          @if (officeholder.showAppointedNotLodged) {
            <div class="prop current">{{ officeholder.officeholderName }}</div>
          } @else if (officeholder.showNameChanged) {
            <div class="prop previous">{{ officeholder.previousOfficeholderName }}</div>
            <div class="prop current">{{ officeholder.officeholderName }}</div>
          } @else if (officeholder.showNameChanged) {
            <div class="prop cease">{{ officeholder.previousOfficeholderName }}</div>
          } @else {
            <div class="prop">{{ officeholder.previousOfficeholderName | defaultValue }}</div>
          }
        </div>

        <div [hidden]="!officeholder.individualId">
          <i class="icon ic-eye-16"></i>
        </div>
      </a>
    </div>

    <div>
      <div class="title">Status</div>
      @if (officeholder.showOfficerCeased) {
        <div class="prop previous">{{ officeholder.previousCessationDate | officerStatus }}</div>
        <div class="prop current">{{ officeholder.cessationDate | officerStatus }}</div>
      } @else {
        <div class="prop">{{ officeholder.cessationDate | officerStatus }}</div>
      }
    </div>

    <div>
      <div class="title">Position</div>
      <div class="prop">{{ typesLabel }}</div>
    </div>

    @if (isSomeDirector) {
      <div>
        <div class="title">Director ID</div>
        @if (officeholder.showAppointedNotLodged) {
          <div class="prop current">{{ officeholder.din | din | defaultValue }}</div>
        }@else {
           <div class="prop">{{ officeholder.individual?.din | din | defaultValue }}</div>
        }
      </div>
    } @else {
      <div>
        <div class="title">Address</div>
        @if (officeholder.previousAddress?.normalizedFullAddress && officeholder.previousAddress?.normalizedFullAddress !== officeholder.address.normalizedFullAddress) {
          <div class="prop previous">
            {{ officeholder.previousAddress?.normalizedFullAddress || '' | titlecase | defaultValue }}
          </div>
          <div class="prop current">
            {{ officeholder.address.normalizedFullAddress || '' | titlecase | defaultValue }}
          </div>
        } @else {
          <div class="prop">
            {{ officeholder.address.normalizedFullAddress || '' | titlecase | defaultValue }}
          </div>
        }
      </div>
    }

    <div>
      <div class="title">Appointment Date</div>
      @if (officeholder.previousAppointmentDate && officeholder.previousAppointmentDate !== officeholder.appointmentDate) {
        <div class="prop previous">{{ officeholder.previousAppointmentDate | dateFormat }}</div>
        <div class="prop current">{{ officeholder.appointmentDate | dateFormat }}</div>
      } @else {
        <div class="prop">{{ officeholder.appointmentDate | dateFormat }}</div>
      }
    </div>

    <div>
      <div class="title">Date of Birth</div>
      <div class="prop">{{ officeholder.dob | dateFormat }}</div>
    </div>

    <div>
      <div class="title">Cessation Date</div>
      @if (officeholder.previousCessationDate && officeholder.previousCessationDate !== officeholder.cessationDate) {
        <div class="prop previous">{{ officeholder.previousCessationDate | dateFormat }}</div>
        <div class="prop current">{{ officeholder.cessationDate | dateFormat }}</div>
      } @else {
        <div class="prop">{{ officeholder.cessationDate | dateFormat }}</div>
      }
    </div>

    <div>
      <div class="title">Place of Birth</div>
      <div class="prop">{{ placeOfBirth }}</div>
    </div>

    @if (isSomeDirector) {
      <div>
        <div class="title">Address</div>
        @if (officeholder.previousAddress?.normalizedFullAddress && officeholder.previousAddress?.normalizedFullAddress !== officeholder.address.normalizedFullAddress) {
          <div class="prop previous">
            {{ officeholder.previousAddress?.normalizedFullAddress || '' | titlecase | defaultValue }}
          </div>
          <div class="prop current">
            {{ officeholder.address.normalizedFullAddress || '' | titlecase | defaultValue }}
          </div>
        } @else {
          <div class="prop">
            {{ officeholder.address.normalizedFullAddress || '' | titlecase | defaultValue }}
          </div>
        }
      </div>
    }
  </div>
</div>
